var _title, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNumber = function SvgNumber(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "iPhone 8")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iPhone-8",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico-number",
    transform: "translate(7.000000, 3.000000)",
    fill: "#001640",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.47753911,16.6666667 L9.47753911,16.1083984 C8.35340711,16.1083984 7.65462244,15.9564887 7.38118489,15.6526692 C7.10774744,15.3488498 6.97102867,14.7715929 6.97102867,13.9208984 L6.97102867,13.9208984 L6.97102867,0.625 L6.56087244,0.625 L0.670572911,3.1656901 L0.670572911,3.75813802 C1.10351562,3.59103732 1.4453125,3.46950954 1.69596354,3.39355469 C2.09092882,3.26443142 2.383355,3.19986979 2.57324222,3.19986979 C2.93023,3.19986979 3.17518444,3.32139757 3.30810544,3.56445312 C3.44102644,3.80750868 3.507487,4.21766493 3.507487,4.79492188 L3.507487,4.79492188 L3.507487,13.7841797 C3.507487,14.6880426 3.34038633,15.301378 3.00618489,15.6241862 C2.67198356,15.9469943 1.9124349,16.1083984 0.727539067,16.1083984 L0.727539067,16.1083984 L0.727539067,16.6666667 L9.47753911,16.6666667 Z",
    id: 1
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNumber, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/number.5541b32a.svg";
export { ForwardRef as ReactComponent };